import React from 'react'

const Image = () => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.615 2.308a.923.923 0 00-.923-.923H5.077a.923.923 0 00-.923.923v16.615a.923.923 0 00.923.923h16.615a.923.923 0 00.923-.923V2.308z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M20.308 16.154L17.855 9.61a.462.462 0 00-.816-.092l-3.193 4.79-1.891-2.27a.462.462 0 00-.75.058l-2.436 4.058M10.154 7.843a1.385 1.385 0 100-2.769 1.385 1.385 0 000 2.77zM22.615 16.151H4.154'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.154 5.077H2.308A.923.923 0 001.385 6v15.692a.923.923 0 00.923.923H18a.923.923 0 00.923-.923v-1.846'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

export default Image
